<template>
    <div id="new_scan_action_prototype">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div v-if="is_loading" class="ui active centered inline loader"></div>
        <div v-else class="ui container">
            <h1 class="ui header">{{ scan_action_prorotype.barcode }}{{ scan_action_prorotype.name }}</h1>
            <table class="ui celled table">
                <thead class="center aligned">
                    <tr>
                        <th class="eight wide">
                            <!-- 欄位名 -->
                            {{ $t('ui.pages.scan_action_prototypes.field_name') }}
                        </th>
                        <th class="eight wide">
                            <!-- 數值 -->
                            {{ $t('ui.pages.scan_action_prototypes.value') }}
                        </th>
                    </tr>
                </thead>
                <tbody class="center aligned ui form">
                    <tr>
                        <!-- <td>條碼號</td> -->
                        <td>{{ $t('models.attributes.scan_action_prototypes.barcode') }}</td>
                        <td>
                            <input type="text" name="barcode" v-model="scan_action_prorotype.barcode">
                        </td>
                    </tr>
                    <tr>
                        <!-- <td>動作名稱</td> -->
                        <td>{{ $t('models.attributes.scan_action_prototypes.name') }}</td>
                        <td>
                            <input type="text" name="name" v-model="scan_action_prorotype.name">
                        </td>
                    </tr>
                    <tr>
                        <!-- <td>設定為初始貨況？</td> -->
                        <td>{{ $t('models.attributes.scan_action_prototypes.is_default') }}？</td>
                        <td class="left aligned">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="scan_action_prorotype.is_default">
                                <label></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <!-- <td>需求條件</td> -->
                        <td>{{ $t('models.attributes.scan_action_prototypes.required_condition') }}</td>
                        <td>
                            <select class="ui fluid dropdown" v-dropdown v-model="scan_action_prorotype.required_condition_identity">
                                <option value="">{{ $t('ui.general.please_select') }}</option>
                                <option v-for="status_prototype in condition_status_prototypes" :value="status_prototype.identity">
                                    {{ status_prototype.polarity ? '+ ':'- ' }}{{ status_prototype.name }}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <!-- <td>前置動作</td> -->
                        <td>{{ $t('models.attributes.scan_action_prototypes.before_actions') }}</td>
                        <td>
                            <textarea name="before_actions" rows="8" cols="80" v-model="scan_action_prorotype.before_actions"></textarea>
                        </td>
                    </tr>
                    <tr>
                        <!-- <td>綁定貨況描述之Scope</td> -->
                        <td>{{ $t('models.attributes.scan_action_prototypes.description_required_scope') }}</td>
                        <td>
                            <textarea name="description_required_scope" rows="8" cols="80" v-model="scan_action_prorotype.description_required_scope"></textarea>
                        </td>
                    </tr>
                    <tr>
                        <!-- <td>綁定貨況描述之候選選項</td> -->
                        <td>{{ $t('models.attributes.scan_action_prototypes.description_options') }}</td>
                        <td>
                            <textarea name="description_options" rows="8" cols="80" v-model="scan_action_prorotype.description_options"></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <table class="ui two column celled table" v-for="(status_prototypes, scope) in scope_grouped_status_prototypes" :status_prototypes="status_prototypes">
                                <thead>
                                    <tr>
                                        <th>{{ human_scope(scope) }}</th>
                                        <th>
                                            <!-- 綁定物料 -->
                                            {{ $t('ui.pages.scan_action_prototypes.binding_material') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="status_prototype in status_prototypes" :status_prototype="status_prototype">
                                        <td>
                                            <div class="ui checkbox">
                                                <input type="checkbox" :value="status_prototype.identity" v-model="scan_action_prorotype.status_prototype_identities">
                                                <label>
                                                    <i class="plus icon" v-if="status_prototype.polarity == true"></i>
                                                    <i class="minus icon" v-else-if="status_prototype.polarity == false"></i>
                                                    {{ status_prototype.name || '-' }}
                                                </label>
                                            </div>
                                        </td>
                                        <td>{{ status_prototype.material_class_name || $t('ui.general.no') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="ui positive basic fluid button" @click.prevent="create_scan_action_prototype">
                {{ $t('ui.general.create') }}
            </button>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "NewScanActionPrototype",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            scan_action_prorotype: {},
            status_prototypes: [],
            errors: [],
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
    },
    computed: {
        scope_grouped_status_prototypes() {
            return _.groupBy(this.status_prototypes, 'scope')
        },
        condition_status_prototypes() {
            return _.filter(this.status_prototypes, status_prototype => {
                return status_prototype.scope  == "condition"
            })
        }
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_loading = false
                this.scan_action_prorotype = {
                    name: "",
                    required_condition_identity: null,
                    barcode: "",
                    before_actions: null,
                    is_default: false,
                    description_required_scope: null,
                    description_options: null,
                    related_columns: [],
                    status_prototype_identities: []
                }
                this.errors = []
                resolve()
            })
            await this.fetch_status_prototypes()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        fetch_status_prototypes() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_status_prototypes).parse(
                {},
                "?" + object_to_query({
                    pagination: false,
                })
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.status_prototypes = response.data.status_prototypes
                    } else {
                        console.log(response.data)
                        this.$noty.error(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error(error.response)
                })
                .then(() => {
                    this.is_loading = false
                })
        },
        create_scan_action_prototype() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_scan_action_prototypes_create).parse(
                {},
                ""
            )
            return axios.post(url, this.scan_action_prorotype, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.$router.push({name: 'scan_action_prototypes'})
                        // this.$noty.success("建立成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.create__name', {
                                name: this.$t('models.scan_action_prototypes')
                            })
                        )
                    } else {
                        console.log(response.data)
                        this.$noty.error(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error(error.response)
                })
                .then(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
        },
        human_scope(original_scope) {
            switch (original_scope) {
                case "operator":
                    return "內部貨況(Operator)"
                    break
                case "forwarder":
                    return "客戶貨況(Forwarder)"
                    break
                case "public":
                    return "公開貨況(Public)"
                    break
                case "mark":
                    return "標記(Mark)"
                    break
                case "condition":
                    return "流程控制(Condition)"
                    break
                case "system":
                    return "系統(System)"
                    break
                default:
                    return "不明(Unknown)"
            }
        },
    },
    components: {
        ErrorMessages,
    }
}
</script>
